export default __webpack_public_path__ + "static/media/bt-logo-transparent.5a954117.png";